import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Failures } from 'src/utils/constants/failures';
import RolePrivateRoute from 'src/components/PrivateRotes/RolePrivateRoute';
import FailuresCategoriesView from './FailuresCategories';

const FailuresView = () => (
  <Routes>
    <Route path=":tab" element={<RolePrivateRoute component={FailuresCategoriesView} />} />
    <Route index element={<Navigate to={Failures.BILLING} replace />} />
  </Routes>
);

export default FailuresView;
